import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class SingleToolSelectorViewModel extends SelectorBaseViewModel<SingleTool> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<SingleTool[]> {
        let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/GetAllSingleTools', {});
        return result.SingleTools.map(x => {
            let t = new SingleTool(this);
            t.id = x.SingleToolId;
            t.title = `${x.SingleToolModelName} (${x.SingleToolModelCode}) - ${x.SerialId}`;
            return t;
        });
    }
}

export class SingleTool extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}